import { createContext } from 'react';
import { AppData } from '../types/AppData';

export const AppProvider = createContext<AppData>({ token: '', type: '', student_id: '', fileLink: '', fileLinkLabel: '', videoUrl: '', drillTitle: '', mbTitle: '', videoButtonLable: '', masteryCardLabel: '', masteryCardPopupLabel: '' });
